import Direction from "views/logic/aggregationbuilder/Direction";
export default class InvestigationsListSortConfig {
  constructor(field, direction) {
    this._value = { field, direction };
  }
  toJSON() {
    const { field, direction } = this._value;
    return {
      field,
      direction: direction === Direction.Ascending ? "ASC" : "DESC"
    };
  }
  static fromJSON({ field, direction }) {
    const directionJSON = Direction.fromJSON(direction === "ASC" ? "Ascending" : "Descending");
    return new InvestigationsListSortConfig(field, directionJSON);
  }
}
